import { render } from "./HospitalTransfusionPage.vue?vue&type=template&id=f4914fee"
import script from "./HospitalTransfusionPage.vue?vue&type=script&lang=js"
export * from "./HospitalTransfusionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__